/* global axios */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getAccountScopedUrl"] }] */

import ApiClient from './ApiClient';

class PixDetectApi extends ApiClient {
  constructor() {
    super('pix_detect', { accountScoped: true });
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  saveConfig(data) {
    return axios.put(`${this.url}/config`, data);
  }

  getReceivers() {
    return axios.get(`${this.url}/receivers`);
  }

  addReceiver(data) {
    return axios.post(`${this.url}/receivers`, data);
  }

  deleteReceiver(id) {
    return axios.delete(`${this.url}/receivers`, { params: { id } });
  }

  getSales(params = {}) {
    return axios.get(`${this.url}/sales`, { params });
  }

  updateSaleStatus(id, status) {
    return axios.patch(`${this.url}/sales`, { id, status });
  }

  deleteSale(id) {
    return axios.delete(`${this.url}/sales`, { params: { id } });
  }

  getOverview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  getPixels() {
    return axios.get(`${this.url}/pixels`);
  }

  addPixel(data) {
    return axios.post(`${this.url}/pixels`, data);
  }

  deletePixel(id) {
    return axios.delete(`${this.url}/pixels`, { params: { id } });
  }

  testDetection(data) {
    return axios.post(`${this.url}/test`, data);
  }
}

export default new PixDetectApi();